/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const parent = table.parentNode;
    // Skip tables already wrapped server-side (CLS fix 2026-07)
    if (!parent || (parent.classList && parent.classList.contains('rte-table-wrapper'))) return;
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
